<template lang="pug">
.content-center
  .overlay
  .back-btn.mb-2(@click="back()")
    i.fa-solid.fa-left-long
    |  {{ $t("ui.back") }} 
  template(v-if="$store.getters.language == 'cn'")
    cnContent
  template(v-else-if="$store.getters.language == 'vi'")
    viContent
  template(v-else-if="$store.getters.language == 'th'")
    thContent
  template(v-else-if="$store.getters.language == 'id'")
    idContent
  template(v-else-if="$store.getters.language == 'kr'")
    krContent
  template(v-else)
    enContent
</template>

<script>
import enContent from "@/components/mobile/rules/en/athletics";
import cnContent from "@/components/mobile/rules/cn/athletics";
import viContent from "@/components/mobile/rules/vi/athletics";
import thContent from "@/components/mobile/rules/th/athletics";
import idContent from "@/components/mobile/rules/id/athletics";
import krContent from "@/components/mobile/rules/kr/athletics";

export default {
  components: {
    enContent,
    cnContent,
    viContent,
    thContent,
    idContent,
    krContent
  },
  computed: {},
  methods: {
    back() {
      this.$router.push("/betting_rules");
    }
  }
};
</script>